import { render, staticRenderFns } from "./addFlightQuotaModal.vue?vue&type=template&id=ffa8f8a2&scoped=true&"
import script from "./addFlightQuotaModal.vue?vue&type=script&lang=ts&"
export * from "./addFlightQuotaModal.vue?vue&type=script&lang=ts&"
import style0 from "./addFlightQuotaModal.vue?vue&type=style&index=0&id=ffa8f8a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffa8f8a2",
  null
  
)

export default component.exports